import { matchResourceFromRoute, ResourceContext } from "@refinedev/core";
import React, { useCallback, useContext } from "react";
import { matchPath, useLocation, useMatch, useParams } from "react-router-dom";
import qs from "qs";
// import { useResourceRootContext } from "@/layouts/ResourceContext";

export const UrlParser = () => {
  let params = useParams();
  const { pathname: originPathname, search } = useLocation();
  const { resources } = useContext(ResourceContext);
  // const { state, dispatch } = useResourceRootContext();
  const matchTenantMode = useMatch('/t/:tenantName/*');
  
  const pathname = React.useMemo(() => {
    if (matchTenantMode) {
      /* if (state.tenantName !== matchTenantMode.params.id) {
        dispatch({ type: 'TENANT_MODE', payload: { tenantName: matchTenantMode.params.id } });
      } */
      return '/' + (matchTenantMode.params['*'] || '');
    }
    /* if (state.tenantName) {
      dispatch({ type: 'TENANT_MODE', payload: false });
    } */
    return originPathname;
  }, [originPathname]);
  const { resource, action, matchedRoute } = React.useMemo(() => {
    const result = matchResourceFromRoute(pathname, resources);
    if (params.action) {
      result.action = params.action;
    }
    return result;
  }, [resources, pathname]);

  // params is empty when useParams is used in a component that is not a child of a Route
  if (Object.entries(params).length === 0 && matchedRoute) {
    params = matchPath(matchedRoute, pathname)?.params || {};
  }

  const fn = useCallback(() => {
    const parsedSearch = qs.parse(search, { ignoreQueryPrefix: true });

    const combinedParams = {
      ...params,
      ...parsedSearch,
    };

    const response = {
      ...(resource && { resource }),
      ...(action && { action }),
      ...(params?.id && { id: decodeURIComponent(params.id) }),
      // ...(params?.action && { action: params.action }), // lets see if there is a need for this
      pathname,
      params: {
        ...combinedParams,
        current: convertToNumberIfPossible(combinedParams.current),
        pageSize: convertToNumberIfPossible(combinedParams.pageSize),
        to: combinedParams.to
          ? decodeURIComponent(combinedParams.to)
          : undefined,
      },
    };

    return response;
  }, [pathname, search, params, resource, action]);

  return fn;
};

export const convertToNumberIfPossible = (value) => {
  if (typeof value === "undefined") {
    return value;
  }
  const num = Number(value);
  if (`${num}` === value) {
    return num;
  }
  return value;
};